import { Card, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CustomTooltip from "./CustomTooltip";

interface CompanyStatisticsTableProps {
    data: any;
}

const CompanyStatisticsTable = ({ data }: CompanyStatisticsTableProps) => {
    const { t } = useTranslation();

    if (!data) return null;

    const tableData = [
        {
            description: t("dashboard.totalCompanies"),
            value: data.totalCompanies || "0",
            tooltip: t("dashboard.tooltips.totalCompanies")
        },
        {
            description: t("dashboard.newCompaniesMonth"),
            value: data.totalSignedCompaniesInLast30Days || "0",
            tooltip: t("dashboard.tooltips.newCompaniesMonth")
        },
        {
            description: t("dashboard.activeCompanies"),
            value: data.totalActiveCompanies || "0",
            tooltip: t("dashboard.tooltips.activeCompanies")
        },
        {
            description: t("dashboard.partiallyActiveCompanies"),
            value: data.totalPartiallyActiveCompanies || "0",
            tooltip: t("dashboard.tooltips.partiallyActiveCompanies")
        },
        {
            description: t("dashboard.inactiveCompanies"),
            value: data.totalInactiveCompanies || "0",
            tooltip: t("dashboard.tooltips.inactiveCompanies")
        }
    ];

    return (
        <Col md={6} className="my-3">
            <Card className="table-card h-100 ">
                <Card.Header>
                    <h5>{t("dashboard.companyStatistics")}</h5>
                </Card.Header>
                <Card.Body className="py-3 px-0">
                    <div className="table-responsive">
                        <table className="table table-hover table-borderless mb-0">
                            <tbody>
                                {tableData.map((item, key) => (
                                    <tr key={key}>
                                        <td>
                                            <CustomTooltip text={item.tooltip}>
                                                <span className="text-muted">{item.description}</span>
                                            </CustomTooltip>
                                        </td>
                                        <td className="text-end f-w-600">{item.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default CompanyStatisticsTable;
